import React, { useEffect, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import { sectorImages } from '../../constants/images';
import { checkIsMobile, checkIsTablet } from '../../utils/deviceUtils';
import '../../styles/sections/sector01.css';

const Sector01 = ({ motionProps }) => {
  const [isMobile, setIsMobile] = useState(checkIsMobile(window.innerWidth));
  const [isTablet, setIsTablet] = useState(checkIsTablet(window.innerWidth));
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(checkIsMobile(width));
      setIsTablet(checkIsTablet(width));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const loadImages = async () => {
      try {
        await Promise.all([
          new Promise((resolve) => {
            const img = new Image();
            img.src = sectorImages.sector01.bg.pc;
            img.onload = resolve;
          }),
          new Promise((resolve) => {
            const img = new Image();
            img.src = sectorImages.sector01.bg.mobile;
            img.onload = resolve;
          }),
          new Promise((resolve) => {
            const img = new Image();
            img.src = sectorImages.sector01.content.pc;
            img.onload = resolve;
          }),
          new Promise((resolve) => {
            const img = new Image();
            img.src = sectorImages.sector01.content.mobile;
            img.onload = resolve;
          }),
          // new Promise((resolve) => {
          //   const img = new Image();
          //   img.src = sectorImages.sector01.logosThree;
          //   img.onload = resolve;
          // })
        ]);
        setIsLoaded(true);
      } catch (error) {
        console.error('Failed to load images:', error);
      }
    };

    loadImages();
  }, []);

  if (!isLoaded) return null;


  const bgImage = sectorImages?.sector01?.bg?.[isMobile ? 'mobile' : 'pc'];
  // const { logosThree } = sectorImages?.sector01 || {};

  const getVideoSize = () => {
    if (isMobile) {
      return {
        width: "480",
        height: "270",
        quality: "large"
      };
    }
    if (isTablet) {
      return {
        width: "640",
        height: "480",
        quality: "hd720"
      };
    }
    return {
      width: "1280",
      height: "720",
      quality: "hd1080"
    };
  };

  const videoSize = getVideoSize();

  return (
    <section 
      className="section_container sector01" 
      style={{ 
        backgroundImage: `url(${bgImage})`
      }}
    >
      <motion.div 
        className="grid"
        {...motionProps}
      >
        <div className="content_container">
          <div className="content_box">
            K-STARTUP GRAND CHALLENGE OVERVIEW
            {/* <img src={content1Image} alt="" className={isMobile ? "mo_viewer" : "pc_viewer"} /> */}
          </div>
          <div className="stats_container">
            {/* <div className="stats_left">
              <div className="stats_item">
                <div className="stats_images">
                  <div className="stat_item">
                    <img src={title1} alt="Total Applicant" className="stats_title" />
                    <span className="stat_value">18,900+</span>
                  </div>
                  <div className="stat_item">
                    <img src={title2} alt="Applicant Countries" className="stats_title" />
                    <span className="stat_value">169+</span>
                  </div>
                  <div className="stat_item">
                    <img src={title3} alt="A Total Prize Pool for 2025" className="stats_title" />
                    <span className="stat_value">$400,000</span>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="stats_right">
              <iframe
                width={videoSize.width}
                height={videoSize.height}
                src={`https://www.youtube.com/embed/868yKzMh3rY?vq=${videoSize.quality}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                // style={{
                //   maxWidth: '100%'
                //   // height: 'auto'
                // }}
              />

              {/* <iframe 
                width="560" 
                height="315" 
                src="https://www.youtube.com/embed/868yKzMh3rY?si=Kp5M31A0EZ2VyrMa" 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen
              /> */}
            </div>

            {/* <div className="logos_three">
              <img src={logosThree} alt="Logos" />
            </div> */}
          </div>
          {/* <div className="logos_three">
            <img src={logosThree} alt="Logos" />
          </div> */}
        </div>
      </motion.div>
    </section>
  );
};

Sector01.propTypes = {
  motionProps: PropTypes.shape({
    initial: PropTypes.object,
    whileInView: PropTypes.object,
    exit: PropTypes.object,
    viewport: PropTypes.object,
    transition: PropTypes.object
  }).isRequired
};

export default Sector01; 